import React, { useContext, useEffect, useState, useCallback } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import { AuthContext } from "../../context/Auth/AuthContext";
import NativeCall from "../NativeCall";
import { isCallActive } from "../callState";

// Escuta "call:incoming" no socket do atendente (só chega para quem está na sala do
// ticket, ou seja, com a conversa aberta) e mostra o aviso de chamada entrando.
const IncomingCall = () => {
  const { socket } = useContext(AuthContext);
  const [incoming, setIncoming] = useState(null); // { ticketId, name }
  const [answering, setAnswering] = useState(null); // ticket-like

  useEffect(() => {
    if (!socket) return undefined;
    const onIncoming = (d) => {
      if (!d || !d.ticketId) return;
      if (isCallActive(d.ticketId)) return; // já em chamada nesse ticket
      setIncoming({ ticketId: d.ticketId, name: d.name });
    };
    socket.on("call:incoming", onIncoming);
    return () => socket.off("call:incoming", onIncoming);
  }, [socket]);

  const accept = useCallback(() => {
    setAnswering({ id: incoming.ticketId, contact: { name: incoming.name } });
    setIncoming(null);
  }, [incoming]);

  const reject = useCallback(() => {
    if (socket && incoming) socket.emit("call:hangup", { ticketId: incoming.ticketId });
    setIncoming(null);
  }, [socket, incoming]);

  return (
    <>
      <Dialog open={!!incoming} onClose={reject} maxWidth="xs" fullWidth>
        <DialogTitle>📞 Chamada de voz</DialogTitle>
        <DialogContent>
          <p style={{ fontSize: 16, margin: "8px 0" }}>
            <b>{incoming?.name || "Cliente"}</b> está ligando…
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={reject} color="secondary">Recusar</Button>
          <Button onClick={accept} variant="contained" color="primary">Atender</Button>
        </DialogActions>
      </Dialog>

      {answering && (
        <NativeCall
          open={!!answering}
          mode="answer"
          ticket={answering}
          onClose={() => setAnswering(null)}
        />
      )}
    </>
  );
};

export default IncomingCall;
